<nav class="saas-app-header">
    <div class="saas-header-left">
        <button type="button" class="saas-header-toggle-btn" (click)="sideNavToggle()" title="Toggle sidebar">
            <i class="fa-solid fa-bars-staggered"></i>
        </button>
        <div class="saas-brand-wrap">
            <img src="assets/aetherpsl-logo.png" alt="Aether HRMS" class="saas-brand-logo">
        </div>
        <div class="saas-header-divider"></div>
        <!-- <div class="saas-workspace-badge">
            <span class="saas-badge-dot"></span>
            <span class="saas-badge-title">HRMS Portal</span>
        </div> -->
    </div>

    <div class="saas-header-center">
        <!-- Optional workspace indicator or breadcrumb -->
    </div>

    <div class="saas-header-right">
        <div class="saas-header-user-wrap dropdown" (hide.bs.dropdown)="onProfileMenuClose()">
            <button type="button" class="saas-user-pill-btn" data-bs-toggle="dropdown" aria-expanded="false" aria-label="Open profile menu">
                <div class="saas-avatar-circle">
                    <span>{{getUserInitials()}}</span>
                </div>
                <div class="saas-user-details d-none d-md-flex">
                    <span class="saas-user-name">{{userFullName}}</span>
                    <!-- <span class="saas-user-role">Workspace User</span> -->
                </div>
                <i class="fa-solid fa-chevron-down saas-dropdown-arrow ms-2"></i>
            </button>

            <ul class="dropdown-menu dropdown-menu-end saas-profile-dropdown shadow-lg mt-2">
                <!-- User summary header -->
                <li class="saas-dropdown-user-summary">
                    <div class="saas-summary-avatar">{{getUserInitials()}}</div>
                    <div class="saas-summary-info">
                        <span class="saas-summary-name">{{userFullName}}</span>
                        <span class="saas-summary-status"><span class="saas-status-dot"></span> Active</span>
                    </div>
                </li>
                <li><hr class="dropdown-divider my-1"></li>

                <li>
                    <a class="dropdown-item saas-dropdown-item" (click)="profileView()">
                        <i class="fa-solid fa-user-gear me-2"></i>
                        <span>Profile Settings</span>
                    </a>
                </li>

                <!-- Theme Submenu -->
                <li class="dropdown-submenu" [class.submenu-open]="isThemeMenuOpen">
                    <button type="button"
                        class="dropdown-item saas-dropdown-item dropdown-toggle d-flex justify-content-between align-items-center"
                        (click)="$event.stopPropagation(); toggleThemeMenu()">
                        <div class="d-flex align-items-center">
                            <i class="fa-solid fa-palette me-2"></i>
                            <span>Theme</span>
                        </div>
                    </button>

                    <ul class="dropdown-menu submenu-side saas-theme-submenu" [class.show-menu]="isThemeMenuOpen">
                        <li class="saas-theme-header">Select Color Theme</li>
                        <li>
                            <button type="button"
                                class="dropdown-item theme-selector theme-default d-flex justify-content-between align-items-center"
                                (click)="setTheme('default')">
                                <span class="d-flex align-items-center">
                                    <span class="theme-color-dot dot-default me-2"></span>
                                    <span>Default (Teal)</span>
                                </span>
                                @if (currentTheme === 'default') { <i class="fa-solid fa-check text-primary ms-2"></i> }
                            </button>
                        </li>
                        <li>
                            <button type="button"
                                class="dropdown-item theme-selector theme-alternate d-flex justify-content-between align-items-center"
                                (click)="setTheme('alternate')">
                                <span class="d-flex align-items-center">
                                    <span class="theme-color-dot dot-alternate me-2"></span>
                                    <span>Alternate (Green)</span>
                                </span>
                                @if (currentTheme === 'alternate') { <i class="fa-solid fa-check text-success ms-2"></i> }
                            </button>
                        </li>
                        <li>
                            <button type="button"
                                class="dropdown-item theme-selector theme-sunset d-flex justify-content-between align-items-center"
                                (click)="setTheme('sunset')">
                                <span class="d-flex align-items-center">
                                    <span class="theme-color-dot dot-sunset me-2"></span>
                                    <span>Sunset (Orange)</span>
                                </span>
                                @if (currentTheme === 'sunset') { <i class="fa-solid fa-check text-warning ms-2"></i> }
                            </button>
                        </li>
                        <li>
                            <button type="button"
                                class="dropdown-item theme-selector theme-midnight d-flex justify-content-between align-items-center"
                                (click)="setTheme('midnight')">
                                <span class="d-flex align-items-center">
                                    <span class="theme-color-dot dot-midnight me-2"></span>
                                    <span>Midnight (Blue)</span>
                                </span>
                                @if (currentTheme === 'midnight') { <i class="fa-solid fa-check text-info ms-2"></i> }
                            </button>
                        </li>
                        <li>
                            <button type="button"
                                class="dropdown-item theme-selector theme-corporate d-flex justify-content-between align-items-center"
                                (click)="setTheme('corporate')">
                                <span class="d-flex align-items-center">
                                    <span class="theme-color-dot dot-corporate me-2"></span>
                                    <span>Corporate (Slate)</span>
                                </span>
                                @if (currentTheme === 'corporate') { <i class="fa-solid fa-check text-primary ms-2"></i> }
                            </button>
                        </li>
                    </ul>
                </li>

                <li><hr class="dropdown-divider my-1"></li>
                <li>
                    <a class="dropdown-item saas-dropdown-item saas-item-logout" href="#" (click)="logOut()">
                        <i class="fa-solid fa-arrow-right-from-bracket me-2"></i>
                        <span>Log out</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</nav>